import { render } from "./WidgetPreviewImg.vue?vue&type=template&id=238d48ef"
import script from "./WidgetPreviewImg.vue?vue&type=script&lang=js"
export * from "./WidgetPreviewImg.vue?vue&type=script&lang=js"

import "./WidgetPreviewImg.vue?vue&type=style&index=0&id=238d48ef&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/WidgetPreviewImg.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "238d48ef"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('238d48ef', __exports__)) {
    api.reload('238d48ef', __exports__)
  }
  
  module.hot.accept("./WidgetPreviewImg.vue?vue&type=template&id=238d48ef", () => {
    api.rerender('238d48ef', render)
  })

}


export default __exports__